import * as React from "react";
const SvgFiRrDemocrat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-democrat_svg__a)">
      <path
        fill="#062147"
        d="m23.66 9.248-2.881-2.526A5 5 0 0 0 17.006 5h-5.671l-2.36-1.77Q9 3.119 9 3V2a1 1 0 0 0-2 0v.101A3.5 3.5 0 0 0 6.171 2q-.085 0-.17.004V2a1 1 0 0 0-2 0v.757q-.283.225-.519.508L.975 6.318a3.34 3.34 0 0 0 0 4.712c.635.635 1.502.97 2.508.97.527 0 1.098-.205 1.793-.514L6 15.099v3.904A3 3 0 0 0 8.996 22a2.98 2.98 0 0 0 2.124-.881A2.94 2.94 0 0 0 11.988 19l4.024.018A3 3 0 0 0 19.005 22a3.006 3.006 0 0 0 2.997-2.995l.005-8.547.335.294c.19.167.425.248.66.248a1 1 0 0 0 .659-1.752m-19.192.41c-.669.296-.904.341-.984.342-.323 0-.776-.067-1.094-.385-.519-.519-.519-1.364.064-1.955l2.57-3.122c.487-.588 1.428-.699 2.04-.241L10.4 6.799a1 1 0 0 0 .6.2h6.006a3.004 3.004 0 0 1 3 2.994l-.002 3.006H7.62l-.38-1.906A1.99 1.99 0 0 0 6.2 9.711a2 2 0 0 0-1.733-.053M19.006 20a1 1 0 0 1-.992-1.012A1.997 1.997 0 0 0 16.02 17h-4.032c-.534 0-1.037.208-1.413.586s-.584.88-.582 1.413A.998.998 0 1 1 8 19.003V15h12.004L20 19.004a1 1 0 0 1-.997.996zm-7.004-10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-8 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-democrat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDemocrat;
